import { useEffect, useState } from 'react'
import { Link, Navigate } from 'react-router-dom'

import { PublicBookShell } from '@/components/booking/PublicBookShell'
import { useUiLocale } from '@/contexts/UiLocaleContext'
import { fetchBookingHub } from '@/lib/api/publicBooking'
import { SALON_DESK_SINGLE_STORE } from '@/lib/salonDeskConfig'

export function BookHubPage() {
  const { t } = useUiLocale()
  const [branches, setBranches] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    fetchBookingHub()
      .then((payload) => setBranches(payload.branches ?? []))
      .catch(() => setError(t('publicBook.hub.errorLoad')))
      .finally(() => setLoading(false))
  }, [t])

  if (!loading && !error && SALON_DESK_SINGLE_STORE && branches.length === 1 && branches[0]?.slug) {
    return <Navigate to={`/book/${branches[0].slug}`} replace />
  }

  return (
    <PublicBookShell>
      <div className="flex min-h-[100dvh] flex-col px-6 pb-10 pt-14">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.42em] text-[#8B7E6E]">
          {t('publicBook.hub.eyebrow')}
        </p>
        <h1 className="mt-4 text-center text-3xl font-extrabold uppercase tracking-tight text-[#1F1611]">
          {t('publicBook.hub.title')}
        </h1>

        {loading ? (
          <p className="mt-10 text-center text-sm text-[#8B7E6E]">{t('common.loading')}</p>
        ) : null}
        {error ? <p className="mt-10 text-center text-sm text-red-600">{error}</p> : null}

        <div className="mt-8 space-y-4">
          {branches.map((branch) => (
            <Link
              key={branch.slug}
              to={`/book/${branch.slug}`}
              className="block overflow-hidden rounded-3xl border border-white bg-white/95 shadow-[0_8px_30px_rgba(58,28,12,0.08)] transition hover:shadow-[0_14px_34px_rgba(58,28,12,0.14)]"
            >
              {branch.hero_image_url ? (
                <img
                  src={branch.hero_image_url}
                  alt=""
                  className="h-36 w-full object-cover"
                />
              ) : null}
              <div className="p-5">
                <p
                  className="text-xs font-bold uppercase tracking-[0.16em]"
                  style={{ color: branch.theme_secondary ?? '#DB2777' }}
                >
                  {branch.hero_subline ?? t('publicBook.hub.fallbackTagline')}
                </p>
                <h2 className="mt-1 text-xl font-extrabold uppercase text-[#1F1611]">{branch.name}</h2>
                {branch.address ? (
                  <p className="mt-2 text-sm text-[#8B7E6E]">{branch.address}</p>
                ) : null}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </PublicBookShell>
  )
}
